import React, {useEffect, useMemo, useState} from 'react'
import './ContactUs.scss'
import ContactForm from 'src/components/ContactForm'


const ContactUs = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME
  const url = process.env.REACT_APP_URL
  const root = document.getElementById('root')
  const [dataFromChild, setDataFromChild] = useState(true)
  root.classList.add('black-bck')

  useEffect(() => {
    document.title = companyName + ' - Contact Us'
    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', `We would love to hear from you.`)
    }

    const linkCanonical = document.querySelectorAll("link[rel='canonical']")[0]
    linkCanonical.setAttribute('href', `${url}contact`)

  }, [])

  const handleDataFromChild = (bool) => {
    setDataFromChild(bool)
  }

  return (
    <section className="contact-us">
      <div className="section-heading">
        <div className="container">
          <h1>Get in Touch</h1>
          <div className="section-description">
            We would love to hear from you. If you have a question or want to learn about our services,
            call <a href="tel:+44 161 726 5172">+44 161 726 5172</a> or
            fill out the form below.
            <br></br> An expert will contact you shortly.
          </div>
        </div>
      </div>

      <div className="container">
        <div className="contact-data">
          <div className="contact-data-item">
            <i className="fa-solid fa-location-dot"></i>
            <h3>EU Office</h3>
            Collentina NR.16
            Bloc B2
            Scara 1, Etaj 9,
            Apt 74, Sector 2
            Bucharest, Romania
          </div>
          <div className="contact-data-item">
            <i className="fa-solid fa-location-dot"></i>
            <h3>UK Office</h3>
            Spring Court,
            Spring Road,
            Hale,
            Altrincham,
            England WA14 2UQ
          </div>
        </div>
      </div>

      <div className="container">
        <ContactForm sendDataToParent={handleDataFromChild} />
      </div>
    </section>
  )
}
export default ContactUs